<!-- src/App.vue -->
<template>
  <div id="app">
    <AuthInfoList />
  </div>
</template>

<script>
import AuthInfoList from '@/view/AuthInfoList.vue'

export default {
  name: 'App',
  components: {
    AuthInfoList
  }
}
</script>